export default __webpack_public_path__ + "img/mBNptsPJ.5c6d574a.svg";